import icoColaboracao from 'assets/img/ico-colaboracao.png';
import icoFocoCliente from 'assets/img/ico-foco-cliente.png';
import icoInovacao from 'assets/img/ico-inovacao.png';
import icoLideranca from 'assets/img/ico-lideranca.png';
import icoProtagonismo from 'assets/img/ico-protagonismo.png';

import { Comportamento } from './perfil-calculos';

/** Ícone de cada comportamento: as Dimensões da aba Reconhecimentos e o bloco Reconhecimentos do Resumo. */
export const ICONE_DO_COMPORTAMENTO: Record<Comportamento, string> = {
  colaboracao: icoColaboracao,
  foco: icoFocoCliente,
  inovacao: icoInovacao,
  resolutividade: icoProtagonismo,
  lideranca: icoLideranca,
};
